module.exports = __webpack_public_path__ + "media/images/icon__checkmark-51b7eb6a05f7f59b52f8b3cacbd7e0bf.png";